export class PetPatientModel {
    tag_no: string
    pet_no: string
    pet_name: string
    owner: string
    first_name: string
    last_name: string
    specie_name: string
    breed_name: string
    specie: string 
    client_no: string
    location: string
    sublocation:string
    status: string

    constructor(
        tag_no: string,
        pet_no: string,
        pet_name: string,
        owner: string,
        first_name: string,
        last_name: string,
        specie_name: string,
        breed_name: string,
        specie: string,
        client_no: string,
        location: string,
        sublocation:string,
        status: string
    ) {
        this.tag_no = tag_no
        this.pet_no = pet_no
        this.pet_name = pet_name
        this.owner = owner
        this.first_name = first_name
        this.last_name = last_name
        this.specie_name = specie_name
        this.breed_name = breed_name
        this.specie = specie
        this.client_no = client_no
        this.location= location
        this.sublocation= sublocation
        this.status= status
    }
} 